import gql from "graphql-tag"
import { MutationHookOptions } from "react-apollo"

import { useFormMutation } from "hooks/useFormMutation"
import { ROOT_QUERY_USER_FRAGMENT } from "graphql/queries/user"
import { UpdateUserMutation, UpdateUserMutationVariables } from "typings/types"

const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($params: UpdateUserParams!, $stripeToken: String) {
    updateUser(user: $params, stripeToken: $stripeToken) {
      ...RootQueryUserFragment
    }
  }
  ${ROOT_QUERY_USER_FRAGMENT}
`

export const useUpdateUser = (options?: MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) =>
  useFormMutation<UpdateUserMutation, UpdateUserMutationVariables>(UPDATE_USER_MUTATION, options)
